<!--
  ~ Copyright (c) 2025. Jellybean B.V.
  ~ Jellybean B.V. Apeldoorn heeft een licentie verleend aan
  ~ Spin in het Web B.V. Apeldoorn voor het gebruik van deze software-
  ~ onderdelen in projecten voor derden. U heeft géén toestemming
  ~ tot inzage of wijziging in de (bron)code van deze onderdelen.
  -->

<input type="text" [disabled]="disabled" [placeholder]="placeholder" [class]="controlClass" [size]="size" [(ngModel)]="ctrlval"
       [name]="naam" [id]="naam"
       (ngModelChange)="valueChanged()" (blur)="ctrlBlur()" (keyup.enter)="enterkey($event)" (focus)="ctrlFocus($event)"
>
